import { render, staticRenderFns } from "./NewsForm.vue?vue&type=template&id=6722a41c&scoped=true"
import script from "./NewsForm.vue?vue&type=script&lang=js"
export * from "./NewsForm.vue?vue&type=script&lang=js"
import style0 from "./NewsForm.vue?vue&type=style&index=0&id=6722a41c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6722a41c",
  null
  
)

export default component.exports